var exports = {
  "WL": "xa15a2ab7--cc2027--buttons_wrapper",
  "Uo": "xa15a2ab7--cc2027--buttons",
  "uK": "xa15a2ab7--cc2027--button_send_message",
  "Km": "xa15a2ab7--cc2027--phones_hint",
};

module.exports = exports;
